var value;
var language;
value = window.location.pathname.split('/')[1];
if(value == 'en') {
	language = 'en';
} else if(value == 'jp') {
	language = 'ja';
} else {
	language = 'es';
}
// console.log(language);
$('#llegada').datetimepicker({
	format: 'MM/DD/YYYY',
	showClose: true,
	locale: language,
	minDate: moment(),
	icons: {
		time: "fa fa-clock-o",
		date: "fa fa-calendar",
		up: "fa fa-chevron-up",
		down: "fa fa-chevron-down",
		previous: "fa fa-chevron-left",
		next: "fa fa-chevron-right",
		today: 'fa fa-crosshairs',
		clear: 'fa fa-trash',
		close: 'fa fa-times'
	}
});
var hamburguer = $('div#Hamburguer');
var menu = $('ul.Main__Navigation');

hamburguer.on('click', function() {
	menu.stop().slideToggle();
});

$('.modal-fullscreen-menu').find('a').on('click', function() {
	$('.modal-fullscreen-menu').modal('hide');
});

$('#fechainicio').datetimepicker({
	format: 'MM/DD/YYYY',
	showClose: true,
	locale: language,
	minDate: moment(),
	icons: {
		time: "fa fa-clock-o",
		date: "fa fa-calendar",
		up: "fa fa-chevron-up",
		down: "fa fa-chevron-down",
		previous: "fa fa-chevron-left",
		next: "fa fa-chevron-right",
		today: 'fa fa-crosshairs',
		clear: 'fa fa-trash',
		close: 'fa fa-times'
	}
});

$('#fechafin').datetimepicker({
	format: 'MM/DD/YYYY',
	showClose: true,
	locale: language,
	minDate: moment(),
	icons: {
		time: "fa fa-clock-o",
		date: "fa fa-calendar",
		up: "fa fa-chevron-up",
		down: "fa fa-chevron-down",
		previous: "fa fa-chevron-left",
		next: "fa fa-chevron-right",
		today: 'fa fa-crosshairs',
		clear: 'fa fa-trash',
		close: 'fa fa-times'
	}
});


$(".dropdown-menu > li > a").click(function () {
	x = $(this).attr("href");
	if(x=="#") { return false; }
});

window.onscroll = function() {

	scrollFunction()}
	;

function scrollFunction() {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
        document.getElementById("botongotop").style.display = "block";
    } else {
        document.getElementById("botongotop").style.display = "none";
    }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    document.body.scrollTop = 0; // For Chrome, Safari and Opera 
    document.documentElement.scrollTop = 0; // For IE and Firefox
}
